import request from "@/utils/request";
import type { RegisterResponseData } from "@/api/user/type";

enum API {
  LOGIN_URL = "/api/user/login",
  REGISTER_URL = "/api/user/register",
  USERINFO_URL = "/api/user/get/login",
  LOGOUT_URL = "/api/user/logout",
  UPDATE_USER_URL = "/api/user/update",
}

export const reqLogin = (data: any) =>
  request.post<any, any>(API.LOGIN_URL, data);

export const reqRegister = (data: any) => {
  return request.post<any, any>(API.REGISTER_URL, data);
};

export const getCurrent = () => {
  return request.get<any, any>(API.USERINFO_URL);
};
export const reqLogOut = () => request.post<any, any>(API.LOGOUT_URL);

// 更新用户信息接口
export interface UserUpdateRequest {
  id: string;
  userName?: string;
  userAvatar?: string;
  userProfile?: string;
  userRole?: string;
  email?: string;
  guideCompleted?: number;
}

export const reqUpdateUser = (data: UserUpdateRequest) => {
  return request.post<any, any>(API.UPDATE_USER_URL, data);
};
